module.exports = __webpack_public_path__ + "img/PH.039d69d7.png";